<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listChannelDigitalSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                    ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol> -->
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
      <!--      <CCol sm="3" md="3" xl="2" xs="12">-->
      <!--        <BaseSelect :options="statusSelect.options" :data="statusSelect.data"-->
      <!--                    ref="statusSelect"></BaseSelect>-->
      <!--      </CCol>-->
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="clickAdd()"
            >
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listChannelDigitalSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #name="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.name }}</span>
            </td>
          </template>
          <template #url="{item}">
            <td>
              <template v-for="each in item.url.split(',')">
                <span :key="each" class="badge badge-light description" style="width: 300px!important;"
                      v-c-tooltip.hover="{content : each, placement: 'left'}">{{ each }}</span><br/>
              </template>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Nghe thử'" square size="sm"
                         @click="submitPreview(item.name, item.url)">
                  <i class="fa fa-bullhorn" aria-hidden="true"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="loadChannelDigitalById(item.id)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal :title="dataSave.idField.data.model ? 'Cập nhật kênh số hóa' : 'Thêm mới kênh số hóa'"
            :show.sync="isShowModal"
            :closeOnBackdrop="false" :size="'lg'">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="dataSave.nameInput.options"
            :data="dataSave.nameInput.data"
            :listener="dataSave.nameInput.listener"
          />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSave.locationSelect.options" :data="dataSave.locationSelect.data"
                      ref="locationSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataSave.urlInput.options" :data="dataSave.urlInput.data"
                        v-model="dataSave.urlInput.data.model"/>
          <br/>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa"
                                                                               :class="dataSave.idField.data.model ? 'fa-check' : 'fa-plus'"></i>
          {{ dataSave.idField.data.model ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </template>
    </CModal>

    <CModal :title="'Nghe thử: ' + previewChannelName" :show.sync="previewModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <audio style="width: 100%;" ref="audioPreview" controls></audio>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i class="fa fa-times"></i> Hủy bỏ
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <audio id="audioPreview"></audio>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import VideoPlayer from "@/views/base/VideoPlayer";
import BaseTextArea from "@/views/base/BaseTextArea";

export default {
  name: "FileType",
  components: {
    BaseTextArea,
    VideoPlayer,
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/channel-digital/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "kênh số hóa",
          that.actionData.model.channelDigitalSelectedName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.channelDigitalSelectedId,
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa lĩnh vực " + that.actionData.model.channelDigitalSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/channel-digital/delete-ids",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các kênh số hóa", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listChannelDigitalSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listChannelDigitalSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách lĩnh vực thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      isShowModal: false,
      previewModal: false,
      previewChannelName: '',
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          channelDigitalSelectedId: null,
          channelDigitalSelectedName: null,
          listChannelDigitalSelectedId: []
        }
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên kênh",
          label: 'Tên kênh'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "checkbox", label: "#", sorter: false, filter: false},
            {key: "createDate", label: "Ngày tạo"},
            {key: "name", label: "Tên kênh"},
            {key: "url", label: "Đường dẫn"},
            {key: "locationName", label: "Địa bàn"},
            {key: "action", label: "Thao tác", _style: 'width:10%', sorter: false, filter: false}
          ],
          slots: ["checkbox", "name", "url", "createDate", "action"],
          lazyLoad: false,
          sorter: true,
          columnFilter: false,
          clickableRows: true,
        },
        dataSource: {
          url: "/channel-digital/list",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          response: function (dataResponse) {
            that.actionData.model.listChannelDigitalSelectedId = [];
            return dataResponse.data;
          },
          resultListAttrName: 'channels',
        }
      },
      dataSave: {
        idField: {
          data: {
            name: "id",
            model: ""
          }
        },
        /* name */
        nameInput: {
          options: {
            label: "Tên kênh số hóa <span class='required'>*</span>",
            placeholder: "Tên kênh số hóa",
          },
          data: {
            name: "name",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.nameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên kênh số hóa không được để trống";
                } else if (value.length > 500) {
                  this.isValid = false;
                  this.errorMessage = "Tên kênh số hóa được quá 500 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        locationSelect: {
          options: {
            lazyLoad: true,
            label: "Đài huyện",
            selectAllText: "Chọn huyện",
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            model: "",
            name: 'locationCode',
            items: [],
            source: {
              url: "/common/findAllLocationByLevel",
              isJsonContentType: false,
              dataSubmit() {
                return {
                  level: 1,
                }
              },
              response: function (dataResponse) {
                that.dataSave.locationSelect.data.items = dataResponse.data
              }
            },
          }
        },
        urlInput: {
          options: {
            label: "URL kênh số hóa <span class='required'>*</span>",
            placeholder: "URL kênh số hóa",
            rows: 5,
          },
          data: {
            name: "url",
            model: "",
            // updateCallback: function () {
            //   that.submitData();
            // },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.urlInput.data.model.trim();
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "URL kênh số hóa không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        }
      },
      hlsPreview: ''
    }
  },
  methods: {
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listChannelDigitalSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listChannelDigitalSelectedId.indexOf(value.item.id)
          if (index > -1) { // only splice array when item is found
            this.actionData.model.listChannelDigitalSelectedId.splice(index, 1); // 2nd parameter means remove one item only
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listChannelDigitalSelectedId.push(value.item.id);
        }
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listChannelDigitalSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listChannelDigitalSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listChannelDigitalSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, channelDigitalSelectedId, channelDigitalSelectedName) {
      let actionData = this.actionData.model;
      actionData.channelDigitalSelectedId = channelDigitalSelectedId || null;
      actionData.channelDigitalSelectedName = channelDigitalSelectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickAdd() {
      this.isShowModal = true;
      this.dataSave.idField.data.model = "";
      this.dataSave.nameInput.data.model = "";
      this.dataSave.urlInput.data.model = "";
    },
    async submitPreview(name, url) {
      let that = this;
      var audio = this.$refs.audioPreview;
      var urlDetail = url.split(',')
      for (var i = 0; i < urlDetail.length; i++) {
        if (urlDetail[i].includes(".mpd")) {

        } else if (urlDetail[i].includes(".m3u8")) {
          var res = await this.loadViewHLS(urlDetail[i], audio);
          if (res != true) {
            audio.play();
            that.previewModal = true;
            that.hlsPreview = res;
            break;
          }
        } else {
          this.showErrorMsg({message: 'Không thể nghe thử'})
        }
      }
      this.previewChannelName = name;
    },
    async loadViewHLS(url, audio) {
      return new Promise((resolve) => {
        if (Hls.isSupported()) {
          var hls = new Hls();
          hls.loadSource(url);
          hls.attachMedia(audio);
          hls.on(Hls.Events.ERROR, function (event, data) {
            var errorFatal = data.fatal;
            resolve(errorFatal);
          });
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            resolve(hls);
          });
        } else {
          this.showErrorMsg({message: 'Không thể nghe thử'})
        }
      })
    },
    closePreviewAudio() {
      if (this.hlsPreview) {
        this.hlsPreview.destroy();
        this.hlsPreview = '';
      }
      this.previewModal = false;
    },
    loadChannelDigitalById(id) {
      let that = this;
      that.isShowModal = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/channel-digital/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: id}
        },
        successCallback: function (response) {
          that.isShowModal = true;
          that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData() {
      let that = this;

      let isValid = true;
      isValid &= that.dataSave.nameInput.data.validator.valid();
      isValid &= that.dataSave.urlInput.data.validator.valid();
      if (!isValid) {
        return;
      }

      let urlSubmit = "/channel-digital/create";
      if (this.dataSave.idField.data.model) {
        urlSubmit = "/channel-digital/update";
      }
      let obj = {};
      obj.url = that.dataSave.urlInput.data.model.trim().split("\n");
      obj.name = that.dataSave.nameInput.data.model;
      obj.id = that.dataSave.idField.data.model;
      obj.locationCode = that.dataSave.locationSelect.data.model;

      this.$helper.loadDataSource({
        loading: that.loading,
        url: urlSubmit,
        dataSubmit: function () {
          return obj;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: that.dataSave.idField.data.model ? "Cập nhật kênh số hóa thành công" : "Thêm mới kênh số hóa thành công"});
            that.isShowModal = false
            that.loadDataMainTable()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listChannelDigitalSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    previewModal(value) {
      if (!value) {
        this.$refs.audioPreview.src = '';
      }
    },
    isShowModal(value) {
      if (value) {
        this.$refs.locationSelect.loadData();
      } else {
        this.dataSave.urlInput.data.model = "";
        this.dataSave.nameInput.data.model = "";
        this.dataSave.idField.data.model = "";
        this.dataSave.locationSelect.data.model = "";
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
